// FlightSchedule.js
import React, { Component } from 'react';
import Calendar from 'fullcalendar-reactwrapper';
import 'fullcalendar-reactwrapper/dist/css/fullcalendar.min.css';
import { navigate } from '../actions/routerResolve';
import { connect } from 'react-redux';
import { Paper } from '@material-ui/core';


class FlightSchedule extends Component {
  constructor(props) {
    super(props);
    
  }

  render() {
    return (
      <Paper 
        style={{
          padding:24, 
          borderRadius:8, 
          overflowY: 'auto'
        }} 
      >
        <Calendar
          id="calendar"
          events={this.props.missions}
          header={{
            left: 'prev,next today',
            center: 'title',
            right: 'month,agendaWeek,agendaDay'
            // right:''
          }}
          defaultView="month"
          editable={false}
          droppable={false}
          eventClick={(calEvent) => this.props.navigate('/flight/' + calEvent.id)}
          contentHeight="auto" // Define a altura do conteúdo para se ajustar ao conteúdo
          locale={'pt-br'} // Configura o idioma para português
          buttonText={{
            today: 'Hoje',
            month: 'Mês',
            week: 'Semana',
            day: 'Dia'
          }}
          // monthNames={[
          //   'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
          //   'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
          // ]}
          // monthNamesShort={[
          //   'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
          //   'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
          // ]}
          // dayNames={[
          //   'Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 
          //   'Quinta-feira', 'Sexta-feira', 'Sábado'
          // ]}
          // dayNamesShort={[
          //   'Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'
          // ]}
        />
      </Paper>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.usersReducer.users
})

const mapDispatchToProps = {
  navigate
};

export default connect(mapStateToProps,mapDispatchToProps)(FlightSchedule);



// WEBPACK FOOTER //
// ./src/components/FlightSchedule.js